import Swiper, { Navigation, Lazy, Scrollbar } from "swiper";

class PartnerSlider {
  wrapper = null;

  constructor(el) {
    this.wrapper = $(el);

    if (this.wrapper.length) {
      this.init();
    }
  }

  init() {
    const partnersEl = $(".partners");
    if (partnersEl.length) {
      const navPrev = partnersEl.find(".swiper-button-prev")[0];
      const navNext = partnersEl.find(".swiper-button-next")[0];
      const scrollbarEl = partnersEl.find(".swiper-scrollbar")[0];
      const dragEl = partnersEl.find(".swiper-scrollbar-drag")[0];

      new Swiper(partnersEl.find(".partners__slider")[0], {
        modules: [Lazy, Navigation, Scrollbar],
        spaceBetween: 20,
        slidesPerView: "auto",
        lazy: {
          loadPrevNext: true,
          loadPrevNextAmount: 3,
        },
        scrollbar: {
          el: scrollbarEl,
          dragEl: dragEl,
          draggable: true,
          dragSize: 19,
          hide: false,
        },
        navigation: {
          prevEl: navPrev,
          nextEl: navNext,
        },

      });
    }
  }
}

export default PartnerSlider;
